import { CardCoordinate, CardTrend } from '../../../models/Card';
import api from '../../../services/api';
import { buildApiHeaders } from '../../../utilities/configUtils';

interface CardType {
  cardName: string;
  coordinates: CardCoordinate[];
  trends: CardTrend[];
}

export interface CardViewerItem {
  assetId: string;
  wellName: string;
  lastCardDateTime: string | null;
  lastCardDateFormatted: string;
  surfaceCard: CardType;
  pocDownholeCard: CardType;
  xDiagDownholeCard: CardType;
  permissibleLoadDown: CardType;
  permissibleLoadUp: CardType;
  loadLimitsAndSetpoints: {
    name: string;
    coordinates: CardCoordinate[];
  }[];
  hasCardData: boolean;
}

export interface CardViewerResponse {
  values: CardViewerItem[];
  totalCount: number;
  pageNumber: number;
  pageSize: number;
  totalPages: number;
  error: string | null;
  isLoading?: boolean;
}

export interface CardViewerParameters {
  groupName: string;
  pageNumber: number;
  pageSize: number;
  cardType: number;
}

// Fetch Card Viewer Data
export const fetchCardViewerAsync = async (
  groupName: string,
  pageNumber: number,
  pageSize: number,
  cardType: number,
): Promise<CardViewerResponse> => {
  try {
    const headers = await buildApiHeaders();
    const response = await api.get(`/Cards/card-viewer`, {
      params: {
        groupName,
        pageNumber,
        pageSize,
        cardType,
      } as CardViewerParameters,
      headers,
    });
    return response.data as CardViewerResponse;
  } catch (error) {
    console.error('Error fetching card viewer data:', error);
    return {
      values: [],
      totalCount: 0,
      pageNumber,
      pageSize,
      totalPages: 0,
      error: 'Failed to fetch card viewer data',
    };
  }
};
